import { render, staticRenderFns } from "./noSign.vue?vue&type=template&id=2a3c147f&scoped=true"
import script from "./noSign.vue?vue&type=script&lang=js"
export * from "./noSign.vue?vue&type=script&lang=js"
import style0 from "./noSign.vue?vue&type=style&index=0&id=2a3c147f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c147f",
  null
  
)

export default component.exports